<template>
<v-menu

  v-model="visible"
  :position-x="pos.x"
  :position-y="pos.y"
  absolute
  :close-on-content-click="true"
>
  <v-card>
    <div
      v-for="(act, a) in event.actions"
      :key="'act-'+a"
      class="text-left d-flex align-center chat-share-host"
    >
      <v-btn x-small class="flex-grow-1" @click="onClickButton(event, act)">
        <v-icon v-if="act.icon" small>{{ act.icon }}</v-icon>
        {{ act.name }}
      </v-btn>
      <rights-indicator :checks="act.id ? actionInspectionChecks(act) : act.typelink === 'del' ? tableInspectionChecks(table, ['delete'], event.otherfields) : []" :label="act.name" />
      <ChatShareMenu v-if="act.id" :modal-key="modalKey" :reference="actionReference(event, act)" label="Partager cette action dans le chat" />
    </div>
  </v-card>
</v-menu>
</template>

<script>
import { tooltipBus } from './tooltipBus'
import ChatShareMenu from '@/components/chat/ChatShareMenu.vue'
import { actionInspectionChecks, tableInspectionChecks } from '../shared/rightsInspectionChecks'
export default {
    name :'MenuC',
    components: { ChatShareMenu },

  data: () => ({
    visible: false,
    event: [],
    pos: { x: 0, y: 0 },
    page : '',
    modalKey : '',
    table: '',
  }),

        methods : {
            actionInspectionChecks,
            tableInspectionChecks,
            actionReference(event, action) {
              return { type: 'action', module_id: this.idmodule, action_id: action.id, page_id: this.page,
                row_id: event.otherfields && (event.otherfields.id || event.otherfields.event_key) || event.id,
                context: { row: event.otherfields || {}, querys: this.$route.query || {} } }
            },

            showMenu({ event, x, y, idmodule, page, modalKey, table = '' }) {
              this.event = JSON.parse(JSON.stringify(event));
              this.event.actions.push({'name':'supprimer',icon:"mdi-trash",typelink:'del',target:''})
              this.page = page
              this.modalKey = modalKey
              this.table = table
              this.idmodule = idmodule
              this.pos = { x, y }
              this.visible = true
            },

            hideMenu() {
              this.visible = false
              this.event = []
            },

            onClickButton: function (item, men) {
           if(men.target=='modal') tooltipBus.$emit('fromthismod',item.id); 
           if(men.typelink=='del') {
            tooltipBus.$emit('delEvent',item);
            return;
           }
            this.clickActions({args:item.otherfields,action:men,idmodule:this.idmodule,page:this.page,modalKey:this.modalKey,
            success:(datas) => {
                if(datas.message) this.$toast.success(datas.message);
                if(men.typelink == 'api') {
                    //rafraich de l'event
                    tooltipBus.$emit('reloadfrommenu',item.id);
                }
            }    
            })

            },

        },

  created() {
    tooltipBus.$on('show-menu', this.showMenu)
    tooltipBus.$on('hide-menu', this.hideMenu)
  },

  beforeDestroy() {
    tooltipBus.$off('show-menu', this.showMenu)
    tooltipBus.$off('hide-menu', this.hideMenu)
  },
}
</script>
